import React from 'react';

import {
    PaypalTransparent,
    KlarnaBadge,
    AmazonPay,
    PayPalCredit,
    Affirm,
    Icon,
} from '@optimaxdev/icons';

import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';

import {flags} from 'libs/rollout';

import s from './bnplOfferPopupList.scss';

export const INSUFFICIENT_FUNDS = 'insufficient_funds';

export const CREDIT_CART_METHODS = [
    PAYMENTS.METHOD_CREDIT_CARD,
    PAYMENTS.METHOD_STRIPE,
    PAYMENTS.METHOD_PRIMER,
];

const creditCardBaseProperties = {
    description: (
        <p className={s.description}>
            <span>Try again with a different card</span>
        </p>
    ),
    isSelected: false,
    name: 'Credit Card',
    title: <p className={s.title}>Credit card</p>,
    titleIcon: {
        icon: null,
        style: {
            width: 0,
        },
    },
};

/**
 * Get buy now, pay later offer popup payment methods list based on flags
 */
export const getBnplOfferPopupList = () => [
    {
        code: flags.checkoutPrimerCreditCard.isEnabled()
            ? PAYMENTS.METHOD_PRIMER
            : PAYMENTS.METHOD_CREDIT_CARD,
        ...creditCardBaseProperties,
    },
    {
        code: PAYMENTS.METHOD_STRIPE,
        ...creditCardBaseProperties,
    },
    {
        code: flags.checkoutPrimerPayPal.isEnabled()
            ? PAYMENTS.METHOD_PRIMER_PAYPAL
            : PAYMENTS.METHOD_PAYPAL_V3,
        description: (
            <p className={s.description}>
                <Icon height={13} icon={PayPalCredit} width={79} />
                <span>or Pay in 4</span>
            </p>
        ),
        isSelected: false,
        name: 'PayPal',
        title: <Icon icon={PaypalTransparent} width={88} />,
    },
    {
        code: flags.checkoutPrimerKlarna.isEnabled()
            ? PAYMENTS.METHOD_PRIMER_KLARNA
            : PAYMENTS.METHOD_KLARNA,
        description: (
            <p className={s.description}>
                <span>Buy now, pay later</span>
            </p>
        ),
        isSelected: false,
        name: 'Klarna',
        title: <Icon icon={KlarnaBadge} width={68} />,
    },
    {
        code: PAYMENTS.METHOD_AMAZON_V2,
        description: (
            <p className={s.description}>
                <span>Pay over time with</span>
                <Icon icon={Affirm} width={45} />
            </p>
        ),
        isSelected: false,
        name: 'Amazon',
        title: <Icon className={s.amazonIcon} icon={AmazonPay} width={104} />,
    },
];
